import { NAVY } from "../constants";

export function HighlightCaption({ box }) {
  if (!box) return null;
  return (
    <div className="absolute top-0" style={{ left: box.left, width: box.width }}>
      <p className="text-center text-[10px] font-black uppercase tracking-wide mb-1" style={{ color: NAVY }}>
        Current
      </p>
      <div className="w-full" style={{ height: 2, background: NAVY }} />
    </div>
  );
}
